export default "__VITE_ASSET__SYD_rAIY__"